import React from 'react';
import styled from 'styled-components';

import GlowingDot from 'components/basic/icons/GlowingDot';
import Link from 'components/basic/Link/Link';
import { useSelectorActiveChain } from 'components/hooks';
import { KATANA_PERPS, MAINTENANCE_MODE, urls } from 'config/constants';
import { formatUsdWithSign } from 'lib/display/formatting';
import { isChainListed } from 'reduxState/exchange/exchangeActiveChainUtils';
import { useSelector } from 'reduxState/store';

// import CookieNoticeComponent from './CookieNotice';
import SocialLinks from './SocialLinks';

const Wrapper = styled.div`
  grid-area: footer;
  height: 24px;
  color: var(--gray4);
  /* background: var(--black1b);
  border-top: 1px solid var(--gray); */
  padding: 0 20px;
  display: flex;
  flex-wrap: wrap;
  /* align-items: center; */
  justify-content: space-between;
`;

const LeftWrap = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`;

const RightWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

const IndicatorWrap = styled.div`
  padding-right: 14px;
  display: flex;
  color: var(--green);
  gap: 4px;
`;

// const ChatPlaceholder = styled.span`
//   display: inline-block;
//   width: 140px;
// `;

const Volume = styled.span`
  padding-left: 5px;
`;

function Footer() {
  const websocketState = useSelector(state => state.exchange.websocketState);
  const katanaChainVolume24hUsd = useSelector(
    state => state.exchange.infoStats.katanaChainVolume24hUsd
  );
  const { activeChain } = useSelectorActiveChain();
  const currentYear = new Date().getFullYear();

  return (
    <Wrapper>
      <LeftWrap>
        <IndicatorWrap>
          <GlowingDot
            color={
              websocketState.orderbookConnected === false
                ? 'red'
                : websocketState.connected === undefined
                ? 'gray'
                : websocketState.connected
                ? 'green'
                : 'red'
            }
            title={
              websocketState.orderbookConnected === false
                ? 'Orderbook offline'
                : websocketState.connected
                ? 'Live data ONLINE'
                : 'Live data offline'
            }
          />
          {websocketState.connected && websocketState.connected
            ? 'Online'
            : null}
        </IndicatorWrap>
      </LeftWrap>
      <RightWrap>
        {!MAINTENANCE_MODE && isChainListed(activeChain) && (
          <Volume>
            {activeChain === 'katanaEVMChain' && (
              <>
                24hr Volume:{' '}
                {katanaChainVolume24hUsd
                  ? formatUsdWithSign(katanaChainVolume24hUsd, { decimals: 0 })
                  : null}
              </>
            )}
          </Volume>
        )}
        <SocialLinks />
        <div>
          &copy; {currentYear} &nbsp;&nbsp;
          <Link href={urls.exchange} color="grayText">
            {KATANA_PERPS}
          </Link>
        </div>
        {/* <Link href={urls.feedbackFormDesktop}>We want your feedback!</Link> */}
        {/* <ChatPlaceholder>
          <LiveChat />
        </ChatPlaceholder> */}
      </RightWrap>

      {/* <CookieNoticeComponent /> */}
    </Wrapper>
  );
}

export default React.memo(Footer);
